import { COLOR1, ORIENTAL_D_GRAY, RADIO_COLOR } from '../../../constants';

export const CustomSelectStyles = {
  label_title: {
    marginBottom: '10px',
    // fontStyle: 'normal',
    // fontWeight: '700',
    // fontSize: '14px',
    lineHeight: '18px',
    // color: '#444444',
    position: 'relative',
    letterSpacing: '0.1px',
    textAlign: 'left',
  },
  select_inputs: {
    border: '1px solid #E2E2E2',
    borderRadius: '6px',
    color: COLOR1,
    font: 'normal normal 400 16px/18px Arial',
    background: '#FFFFFF',
    opacity: 1,
    height: '48px',
    textAlign: 'left',
    letterSpacing: '0.1px',
    '& .MuiOutlinedInput-input': {
      padding: '11.5px 14px',
    },
    '& fieldset': {
      borderRadius: '6px',
      border: '1px solid #E4E9F2',
    },
    '& ::-webkit-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& ::-moz-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& :-ms-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
  },
  select_inputs_err: {
    '& fieldset': {
      borderRadius: '6px',
      border: '1px solid #FD0000 !important',
    },
  },
  select_inputs_disabled: {
    background: '#F3F3F3 !important',
    border: '1px solid #E4E9F2 !important',
    '& fieldset': {
      borderRadius: '6px',
      border: '1px solid #E4E9F2 !important',
    },
    '& ::-webkit-input-placeholder': {
      color: '#E4E9F2 !important',
    },
    '& ::-moz-placeholder': {
      color: '#E4E9F2 !important',
    },
    '& :-ms-input-placeholder': {
      color: '#E4E9F2 !important',
    },
  },
  select_inputs_ACC: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    alignItems: 'center !important',
    border: '1px solid #E2E2E2',
    borderRadius: '6px',
    color: COLOR1,
    font: 'normal normal 400 16px/18px Arial',
    background: '#FFFFFF',
    opacity: 1,
    height: '48px',
    textAlign: 'left',
    letterSpacing: '0.1px',
    '& .MuiOutlinedInput-input': {
      padding: '11px 32px 11px 11px',
      display: 'flex !important',
      justifyContent: 'space-between !important',
      alignItems: 'center !important',
    },
    '& fieldset': {
      borderRadius: '6px',
      border: '1px solid #E4E9F2',
    },
    '& ::-webkit-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& ::-moz-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& :-ms-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
  },
  select_inputs_placeholder: {
    background: '#FFFFFF',
    textAlign: 'left',
    boxSizing: 'border-box',
    fontWeight: 400,
    lineHeight: '20px',
    fontStyle: 'normal',
    fontSize: '16px',
    letterSpacing: '0.1px',
    color: '#808285',
    opacity: 0.8,
  },
  select_icon: {
    color: RADIO_COLOR,
    opacity: 1,
    right: '10px',
  },
  select_icon_plaid: {
    color: RADIO_COLOR,
    opacity: 1,
    right: '-7px',
  },
  select_style: {
    background: '#FFFFFF',
    textAlign: 'left',
    fontWeight: 300,
    lineHeight: '16px',
    fontStyle: 'normal',
    fontSize: '14px',
    letterSpacing: '0.1px',
    color: COLOR1,
    opacity: 1,
  },
  disable_select_style: {
    background: '#F3F3F3',
    textAlign: 'left',
    fontWeight: 300,
    lineHeight: '16px',
    fontStyle: 'normal',
    fontSize: '14px',
    letterSpacing: '0.1px',
    opacity: 1,
  },
  disable_select_style_accno: {
    background: '#F3F3F3',
    textAlign: 'left',
    fontWeight: 700,
    lineHeight: 'normal',
    fontStyle: 'normal',
    fontSize: '16px',
    letterSpacing: '0.1px',
    opacity: 1,
  },
  select_style_accno: {
    background: '#FFFFFF',
    textAlign: 'left',
    fontWeight: 700,
    lineHeight: 'normal',
    fontStyle: 'normal',
    fontSize: '16px',
    letterSpacing: '0.1px',
    color: COLOR1,
    opacity: 1,
    paddingRight: '30px',
  },
  select_inputs_placeholder_accno: {
    background: '#FFFFFF',
    textAlign: 'left',
    boxSizing: 'border-box',
    fontWeight: 700,
    lineHeight: 'normal',
    fontStyle: 'normal',
    fontSize: '16px',
    letterSpacing: '0.1px',
    color: '#000000',
    opacity: 0.8,
  },
  paddingAccountNo: {
    marginRight: '80px !important',
    '@media (min-width:960px) and (max-width:1244px)': {
      marginRight: '80px !important',
    },
  },
  select_inputs_accno: {
    border: '1px solid #E2E2E2',
    borderRadius: '6px',
    color: COLOR1,
    font: 'normal normal 700 16px/18px Arial',
    background: '#FFFFFF',
    opacity: 1,
    height: '18px',
    textAlign: 'left',
    letterSpacing: '0.1px',
    '& .MuiSelect-select': {
      paddingRight: '35px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& .MuiOutlinedInput-input': {
      padding: '0px',
    },
    '&:focus': {
      backgroundColor: 'transparent !important',
      border: 'none !important',
    },
    '& fieldset': {
      border: 'none !important',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      border: 'none !important',
      '& fieldset': {
        border: 'none !important',
      },
    },
    borderBottom: 'none !important',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      borderBottom: 'none !important',
    },
    '& ::-webkit-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& ::-moz-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& :-ms-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
  },
  select_inputs_err_accno: {
    '& fieldset': {
      borderRadius: '6px',
      border: '1px solid #FD0000 !important',
    },
  },
  select_inputs_disabled_accno: {
    background: '#F3F3F3 !important',
    '& ::-webkit-input-placeholder': {
      color: '#E4E9F2 !important',
    },
    '& ::-moz-placeholder': {
      color: '#E4E9F2 !important',
    },
    '& :-ms-input-placeholder': {
      color: '#E4E9F2 !important',
    },
  },
};
